import axios from "api/axios";

export const uploadImageRequest = async (file: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append("image", file);

  return await axios({
    method: "POST",
    url: "/upload/image/single",
    data: bodyFormData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadFileRequest = async (file: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append("image", file);

  return await axios({
    method: "POST",
    url: "/upload/file/single",
    data: bodyFormData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
